var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import { getGambler as getGamblerAction } from "../../actions/profile/creators/profile";
import { rechargeExpay as rechargeExpayAction, clearRechargeExpay, checkExpayStatus as checkExpayStatusAction } from "../../actions/recharge/creators/expay";
import { checkRechargeBironex as checkRechargeBironexAction, createRechargeBironex as createRechargeBironexAction, initRechargeBironex as initRechargeBironexAction, restoreRechargeBironexBlock as restoreRechargeBironexBlockAction, clearRechargeBironexBlock as clearRechargeBironexBlockAction } from "../../actions/bironex";
import { getChequeBlockRemaining, clearChequeBlock, } from "../../shared/chequeBlockStorage";
import { resourceNames } from "../../constants/accountResourceNames";
import Bironex from "./Bironex";
import Uzcard from "./Uzcard";
import * as AccountResources from "../../constants/accountResourceNames";
var Recharge = /** @class */ (function (_super) {
    __extends(Recharge, _super);
    function Recharge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pin: undefined,
        };
        _this.componentDidMount = function () {
            _this.props.getGamblerAction();
            _this.restoreChequeBlock();
        };
        _this.restoreChequeBlock = function () {
            var user = _this.props.user;
            if (!user || !user.gamblerId) {
                return;
            }
            var remaining = getChequeBlockRemaining(user.gamblerId);
            if (remaining > 0) {
                _this.props.restoreRechargeBironexBlockAction({ timeout: remaining });
                return;
            }
            clearChequeBlock(user.gamblerId);
            _this.props.clearRechargeBironexBlockAction();
        };
        _this.handleBlockExpire = function () {
            _this.props.clearRechargeBironexBlockAction();
        };
        _this.handleSubmit = function (data) {
            var user = _this.props.user;
            data.gamblerId = user.gamblerId;
            var pin = data.pin.replace(/\s/g, "");
            data.pin = pin;
            _this.setState({ pin: pin });
            _this.props.checkRechargeBironexAction(data);
        };
        _this.handleCreate = function () {
            _this.props.createRechargeBironexAction({
                gamblerId: _this.props.user.gamblerId,
                pin: _this.state.pin
            });
        };
        return _this;
    }
    Recharge.prototype.componentDidUpdate = function (prevProps) {
        var prevGamblerId = prevProps.user && prevProps.user.gamblerId;
        var gamblerId = this.props.user && this.props.user.gamblerId;
        if (!prevGamblerId && gamblerId) {
            this.restoreChequeBlock();
        }
    };
    Recharge.prototype.componentWillUnmount = function () {
        this.props.initRechargeBironexAction();
    };
    Recharge.prototype.render = function () {
        var _a = this.props, user = _a.user, recharge = _a.recharge, languageId = _a.languageId;
        var pin = this.state.pin;
        if (user === undefined) {
            return false;
        }
        var bironexProps = {
            user: user,
            handleSubmit: this.handleSubmit,
            handleCreate: this.handleCreate,
            clearProps: this.props.initRechargeBironexAction,
            onBlockExpire: this.handleBlockExpire,
            recharge: recharge.get("bironex"),
            languageId: languageId,
            currency: resourceNames[user.accountResourceId],
            pin: pin,
        };
        var uzcardProps = {
            expay: recharge.get("expay"),
            user: user,
            languageId: languageId,
            rechargeExpay: this.props.rechargeExpayAction,
            clearRechargeExpay: this.props.clearRechargeExpay,
            checkExpayStatus: this.props.checkExpayStatusAction
        };
        var renderer = [];
        switch (user.accountResourceId) {
            case AccountResources.UZ:
                renderer.push(_jsx(Uzcard, __assign({}, uzcardProps), uzcardProps.languageId));
                break;
            case AccountResources.US:
                renderer.push(_jsx(Bironex, __assign({}, bironexProps), bironexProps.languageId));
                break;
            default:
                break;
        }
        return (_jsxs("div", __assign({ id: "content" }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 \u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0447\u0435\u0442\u0430"] }) }), _jsx("div", { children: renderer })] })));
    };
    return Recharge;
}(React.Component));
Recharge.propTypes = {
    user: PropTypes.object.isRequired,
    recharge: PropTypes.object.isRequired,
    getGamblerAction: PropTypes.func.isRequired,
    rechargeExpayAction: PropTypes.func.isRequired,
    clearRechargeExpay: PropTypes.func.isRequired,
    checkExpayStatusAction: PropTypes.func.isRequired,
    checkRechargeBironexAction: PropTypes.func.isRequired,
    createRechargeBironexAction: PropTypes.func.isRequired,
    initRechargeBironexAction: PropTypes.func.isRequired,
    restoreRechargeBironexBlockAction: PropTypes.func.isRequired,
    clearRechargeBironexBlockAction: PropTypes.func.isRequired,
};
var mapStateToProps = function (state) { return ({
    user: state.auth.user,
    languageId: state.application.get("languageId"),
    recharge: state.recharge
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getGamblerAction: getGamblerAction,
        rechargeExpayAction: rechargeExpayAction,
        clearRechargeExpay: clearRechargeExpay,
        checkExpayStatusAction: checkExpayStatusAction,
        checkRechargeBironexAction: checkRechargeBironexAction,
        createRechargeBironexAction: createRechargeBironexAction,
        initRechargeBironexAction: initRechargeBironexAction,
        restoreRechargeBironexBlockAction: restoreRechargeBironexBlockAction,
        clearRechargeBironexBlockAction: clearRechargeBironexBlockAction,
    }, dispatch);
};
Recharge = withRouter(connect(mapStateToProps, mapDispatchToProps)(Recharge));
export default injectIntl(Recharge);



// WEBPACK FOOTER //
// ./src/components/recharge/Recharge.jsx